export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      quote: 'Get Quote',
      tracking: 'Track Shipment',
      gallery: 'Gallery',
      contact: 'Contact'
    },
    hero: {
      title: 'Global Logistics Solutions',
      subtitle: 'Your Trusted Partner in International Shipping, Import-Export & Freight Forwarding',
      cta: 'Request a Quote',
      whatsapp: 'Contact Us via WhatsApp'
    },
    about: {
      title: 'About COZEY YILDIZ EXPORT',
      description: 'COZEY YILDIZ EXPORT L.L.C is a premier cargo agent and freight forwarder specializing in international trade portfolios. With years of expertise in global logistics, we connect businesses across continents, ensuring seamless shipping solutions and reliable sourcing services.',
      subtitle: 'Excellence in Global Trade Since Our Inception'
    },
    services: {
      title: 'Our Core Services',
      subtitle: 'Comprehensive logistics solutions tailored for your business needs',
      ocean: {
        title: 'LCL & FCL Ocean Freight',
        description: 'Specialized in less-than-container-load (LCL/Partial shipping) and full container ocean freight. We coordinate with major global shipping lines including MSC and CMA CGM to ensure your cargo reaches its destination safely and on time.',
        features: ['Flexible Container Options', 'Global Shipping Lines', 'Competitive Rates', 'Real-time Tracking']
      },
      sourcing: {
        title: 'Product Sourcing from China',
        description: 'Our new direct Shopping and Sourcing Service from China helps you secure quality commercial goods. We handle supplier verification, quality control, and procurement to streamline your supply chain.',
        features: ['Supplier Verification', 'Quality Control', 'Competitive Pricing', 'Direct Sourcing']
      },
      customs: {
        title: 'Customs Clearance & Logistics',
        description: 'Expert handling of customs operations at major regional ports including Latakia, Jebel Ali, Qingdao, and other global trade hubs. We ensure compliance and efficient clearance processes.',
        features: ['Fast Clearance', 'Documentation Support', 'Compliance Expertise', 'Multi-Port Operations']
      }
    },
    testimonials: {
      title: 'Trusted by Global Merchants',
      subtitle: 'What our clients say about us',
      items: [
        {
          name: 'Ahmed Al-Rashid',
          company: 'Al-Rashid Trading Co.',
          text: 'COZEY YILDIZ has been instrumental in streamlining our import operations from China. Their professionalism and attention to detail are unmatched.',
          rating: 5
        },
        {
          name: 'Maria Gonzalez',
          company: 'Mediterranean Imports Ltd.',
          text: 'Reliable, efficient, and always on time. Their customs clearance service has saved us countless hours and headaches.',
          rating: 5
        },
        {
          name: 'Robert Chen',
          company: 'Global Trade Solutions',
          text: 'Outstanding service quality and competitive pricing. They handle our FCL shipments with exceptional care and transparency.',
          rating: 5
        }
      ]
    },
    gallery: {
      title: 'Our Global Network',
      subtitle: 'Operating at major ports and trade hubs worldwide'
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          question: 'What is the difference between LCL and FCL shipping?',
          answer: 'LCL (Less than Container Load) is ideal for smaller shipments that don\'t require a full container, allowing you to share space with other cargo. FCL (Full Container Load) is for larger shipments where you rent the entire container exclusively.'
        },
        {
          question: 'Which shipping lines do you work with?',
          answer: 'We partner with major global shipping lines including MSC, CMA CGM, and other leading carriers to ensure reliable and cost-effective freight solutions worldwide.'
        },
        {
          question: 'How long does customs clearance typically take?',
          answer: 'Customs clearance time varies by port and cargo type, but typically ranges from 2-5 business days. Our expert team expedites the process to minimize delays.'
        },
        {
          question: 'Can you help with sourcing products from China?',
          answer: 'Yes! Our dedicated China sourcing service includes supplier verification, quality control, procurement, and logistics coordination to ensure you receive quality products at competitive prices.'
        },
        {
          question: 'What ports do you operate at?',
          answer: 'We handle operations at major ports including Latakia (Syria), Jebel Ali (UAE), Qingdao (China), and other strategic global trade hubs.'
        }
      ]
    },
    contact: {
      title: 'Get a Shipping Quote',
      subtitle: 'Submit your cargo inquiry and our team will respond within 24 hours',
      form: {
        name: 'Full Name',
        email: 'Email Address',
        phone: 'Phone Number',
        company: 'Company Name',
        service: 'Service Needed',
        serviceOptions: {
          ocean: 'Ocean Freight (LCL/FCL)',
          sourcing: 'Product Sourcing from China',
          customs: 'Customs Clearance',
          other: 'Other Services'
        },
        message: 'Your Message / Inquiry Details',
        submit: 'Submit Inquiry'
      },
      info: {
        title: 'Contact Information',
        office: 'Office Location',
        officeAddress: 'Al-Amirkan Neighborhood, Latakia, Syria',
        whatsapp: 'WhatsApp Support',
        email: 'Email'
      }
    },
    footer: {
      company: 'COZEY YILDIZ EXPORT L.L.C',
      description: 'Your trusted partner in international shipping, freight forwarding, and global logistics solutions.',
      services: 'Services',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      rights: 'All rights reserved.'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'الخدمات',
      quote: 'طلب تسعير',
      tracking: 'تتبع الشحنة',
      gallery: 'المعرض',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'حلول لوجستية عالمية',
      subtitle: 'شريكك الموثوق في الشحن الدولي والاستيراد والتصدير والشحن',
      cta: 'اطلب عرض سعر',
      whatsapp: 'تواصل معنا عبر واتساب'
    },
    about: {
      title: 'عن COZEY YILDIZ EXPORT',
      description: 'COZEY YILDIZ EXPORT L.L.C هي وكيل شحن ووكيل شحن رائد متخصص في محافظ التجارة الدولية. مع سنوات من الخبرة في الخدمات اللوجستية العالمية، نربط الشركات عبر القارات، مما يضمن حلول شحن سلسة وخدمات توريد موثوقة.',
      subtitle: 'التميز في التجارة العالمية منذ تأسيسنا'
    },
    services: {
      title: 'خدماتنا الأساسية',
      subtitle: 'حلول لوجستية شاملة مصممة خصيصاً لاحتياجات عملك',
      ocean: {
        title: 'الشحن البحري LCL و FCL',
        description: 'متخصصون في الشحن الجزئي (LCL) والشحن بالحاوية الكاملة. نتعاون مع خطوط الشحن العالمية الرئيسية بما في ذلك MSC و CMA CGM لضمان وصول شحنتك بأمان وفي الوقت المحدد.',
        features: ['خيارات حاويات مرنة', 'خطوط شحن عالمية', 'أسعار تنافسية', 'تتبع في الوقت الفعلي']
      },
      sourcing: {
        title: 'التوريد من الصين',
        description: 'خدمة التسوق والتوريد المباشر الجديدة من الصين تساعدك على تأمين سلع تجارية عالية الجودة. نتولى التحقق من الموردين ومراقبة الجودة والمشتريات لتبسيط سلسلة التوريد الخاصة بك.',
        features: ['التحقق من الموردين', 'مراقبة الجودة', 'أسعار تنافسية', 'التوريد المباشر']
      },
      customs: {
        title: 'التخليص الجمركي واللوجستيات',
        description: 'خبرة في التعامل مع العمليات الجمركية في الموانئ الإقليمية الرئيسية بما في ذلك اللاذقية وجبل علي وتشينغداو ومراكز التجارة العالمية الأخرى. نضمن الامتثال وعمليات تخليص فعالة.',
        features: ['تخليص سريع', 'دعم التوثيق', 'خبرة الامتثال', 'عمليات متعددة الموانئ']
      }
    },
    testimonials: {
      title: 'موثوق بنا من قبل التجار العالميين',
      subtitle: 'ماذا يقول عملاؤنا عنا',
      items: [
        {
          name: 'أحمد الرشيد',
          company: 'شركة الرشيد التجارية',
          text: 'كانت COZEY YILDIZ حاسمة في تبسيط عمليات الاستيراد من الصين. احترافيتهم واهتمامهم بالتفاصيل لا مثيل لها.',
          rating: 5
        },
        {
          name: 'ماريا غونزاليس',
          company: 'شركة الواردات المتوسطية المحدودة',
          text: 'موثوقة وفعالة ودائماً في الوقت المحدد. خدمة التخليص الجمركي وفرت لنا ساعات لا تحصى ومتاعب.',
          rating: 5
        },
        {
          name: 'روبرت تشين',
          company: 'حلول التجارة العالمية',
          text: 'جودة خدمة متميزة وأسعار تنافسية. يتعاملون مع شحناتنا FCL بعناية واضحة استثنائية.',
          rating: 5
        }
      ]
    },
    gallery: {
      title: 'شبكتنا العالمية',
      subtitle: 'نعمل في الموانئ الرئيسية ومراكز التجارة في جميع أنحاء العالم'
    },
    faq: {
      title: 'الأسئلة الشائعة',
      items: [
        {
          question: 'ما الفرق بين الشحن LCL و FCL؟',
          answer: 'LCL (أقل من حمولة الحاوية) مثالي للشحنات الصغيرة التي لا تتطلب حاوية كاملة، مما يسمح لك بمشاركة المساحة مع شحنات أخرى. FCL (حمولة الحاوية الكاملة) للشحنات الأكبر حيث تستأجر الحاوية بالكامل حصرياً.'
        },
        {
          question: 'ما هي خطوط الشحن التي تعملون معها؟',
          answer: 'نتعاون مع خطوط الشحن العالمية الرئيسية بما في ذلك MSC و CMA CGM وغيرها من الشركات الرائدة لضمان حلول شحن موثوقة وفعالة من حيث التكلفة في جميع أنحاء العالم.'
        },
        {
          question: 'كم من الوقت يستغرق التخليص الجمركي عادة؟',
          answer: 'يختلف وقت التخليص الجمركي حسب الميناء ونوع الشحنة، ولكنه يتراوح عادةً من 2-5 أيام عمل. فريقنا الخبير يسرع العملية لتقليل التأخير.'
        },
        {
          question: 'هل يمكنكم المساعدة في توريد المنتجات من الصين؟',
          answer: 'نعم! تشمل خدمة التوريد من الصين التحقق من الموردين ومراقبة الجودة والمشتريات وتنسيق الخدمات اللوجستية لضمان حصولك على منتجات عالية الجودة بأسعار تنافسية.'
        },
        {
          question: 'في أي موانئ تعملون؟',
          answer: 'نتعامل مع العمليات في الموانئ الرئيسية بما في ذلك اللاذقية (سوريا) وجبل علي (الإمارات) وتشينغداو (الصين) ومراكز التجارة العالمية الاستراتيجية الأخرى.'
        }
      ]
    },
    contact: {
      title: 'احصل على عرض أسعار الشحن',
      subtitle: 'قدم استفسار الشحن الخاص بك وسيرد فريقنا خلال 24 ساعة',
      form: {
        name: 'الاسم الكامل',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        company: 'اسم الشركة',
        service: 'الخدمة المطلوبة',
        serviceOptions: {
          ocean: 'الشحن البحري (LCL/FCL)',
          sourcing: 'التوريد من الصين',
          customs: 'التخليص الجمركي',
          other: 'خدمات أخرى'
        },
        message: 'رسالتك / تفاصيل الاستفسار',
        submit: 'إرسال الاستفسار'
      },
      info: {
        title: 'معلومات الاتصال',
        office: 'موقع المكتب',
        officeAddress: 'حي الأميركان، اللاذقية، سوريا',
        whatsapp: 'دعم واتساب',
        email: 'البريد الإلكتروني'
      }
    },
    footer: {
      company: 'COZEY YILDIZ EXPORT L.L.C',
      description: 'شريكك الموثوق في الشحن الدولي وإعادة الشحن وحلول الخدمات اللوجستية العالمية.',
      services: 'الخدمات',
      quickLinks: 'روابط سريعة',
      contact: 'اتصل بنا',
      rights: 'جميع الحقوق محفوظة.'
    }
  },
  tr: {
    nav: {
      home: 'Anasayfa',
      about: 'Hakkımızda',
      services: 'Hizmetler',
      quote: 'Teklif Al',
      tracking: 'Kargo Takip',
      gallery: 'Galeri',
      contact: 'İletişim'
    },
    hero: {
      title: 'Küresel Lojistik Çözümleri',
      subtitle: 'Uluslararası Nakliye, İthalat-İhracat ve Yük Taşımacılığında Güvenilir Ortağınız',
      cta: 'Teklif Al',
      whatsapp: 'WhatsApp ile İletişime Geçin'
    },
    about: {
      title: 'COZEY YILDIZ EXPORT Hakkında',
      description: 'COZEY YILDIZ EXPORT L.L.C, uluslararası ticaret portföylerinde uzmanlaşmış birinci sınıf bir kargo acentesi ve nakliye yönlendiricisidir. Küresel lojistikte yılların deneyimi ile kıtalar arası işletmeleri birbirine bağlıyor, kusursuz nakliye çözümleri ve güvenilir tedarik hizmetleri sağlıyoruz.',
      subtitle: 'Kuruluşumuzdan Beri Küresel Ticarette Mükemmellik'
    },
    services: {
      title: 'Temel Hizmetlerimiz',
      subtitle: 'İşletmenizin ihtiyaçlarına göre uyarlanmış kapsamlı lojistik çözümleri',
      ocean: {
        title: 'LCL ve FCL Deniz Taşımacılığı',
        description: 'Tam konteyner altı yük (LCL/Kısmi nakliye) ve tam konteyner deniz taşımacılığında uzmanlaşmış. MSC ve CMA CGM gibi büyük küresel nakliye hatlarıyla koordinasyon sağlıyoruz.',
        features: ['Esnek Konteyner Seçenekleri', 'Küresel Nakliye Hatları', 'Rekabetçi Fiyatlar', 'Gerçek Zamanlı Takip']
      },
      sourcing: {
        title: 'Çin\'den Ürün Tedariki',
        description: 'Yeni doğrudan Çin\'den Alışveriş ve Tedarik Hizmetimiz, kaliteli ticari malları güvence altına almanıza yardımcı olur. Tedarikçi doğrulama, kalite kontrol ve satın alma işlemlerini üstleniyoruz.',
        features: ['Tedarikçi Doğrulama', 'Kalite Kontrolü', 'Rekabetçi Fiyatlandırma', 'Doğrudan Tedarik']
      },
      customs: {
        title: 'Gümrük İşlemleri ve Lojistik',
        description: 'Latakya, Cebel Ali, Qingdao ve diğer küresel ticaret merkezleri dahil olmak üzere büyük bölgesel limanlardaki gümrük işlemlerinde uzman.',
        features: ['Hızlı Gümrükleme', 'Belge Desteği', 'Uyum Uzmanlığı', 'Çoklu Liman Operasyonları']
      }
    },
    testimonials: {
      title: 'Küresel Tüccarların Güvendiği',
      subtitle: 'Müşterilerimiz bizim hakkımızda ne diyor',
      items: [
        {
          name: 'Ahmed Al-Rashid',
          company: 'Al-Rashid Trading Co.',
          text: 'COZEY YILDIZ, Çin\'den ithalat operasyonlarımızı düzene sokmada belirleyici oldu. Profesyonellikleri ve detaylara verdikleri önem eşsiz.',
          rating: 5
        },
        {
          name: 'Maria Gonzalez',
          company: 'Mediterranean Imports Ltd.',
          text: 'Güvenilir, verimli ve her zaman zamanında. Gümrük hizmetleri sayısız saat ve baş ağrısından bizi kurtardı.',
          rating: 5
        },
        {
          name: 'Robert Chen',
          company: 'Global Trade Solutions',
          text: 'Olağanüstü hizmet kalitesi ve rekabetçi fiyatlandırma. FCL sevkiyatlarımızı olağanüstü özen ve şeffaflıkla ele alıyorlar.',
          rating: 5
        }
      ]
    },
    gallery: {
      title: 'Küresel Ağımız',
      subtitle: 'Dünya çapındaki büyük limanlarda ve ticaret merkezlerinde faaliyet gösteriyoruz'
    },
    faq: {
      title: 'Sıkça Sorulan Sorular',
      items: [
        {
          question: 'LCL ve FCL nakliyesi arasındaki fark nedir?',
          answer: 'LCL (Tam Konteyner Altı Yük), tam bir konteyner gerektirmeyen daha küçük sevkiyatlar için idealdir ve alanı diğer kargolarla paylaşmanıza olanak tanır. FCL (Tam Konteyner Yükü), konteynerin tamamını münhasıran kiraladığınız daha büyük sevkiyatlar içindir.'
        },
        {
          question: 'Hangi nakliye hatlarıyla çalışıyorsunuz?',
          answer: 'Dünya çapında güvenilir ve maliyet-etkin nakliye çözümleri sağlamak için MSC, CMA CGM ve diğer önde gelen taşıyıcılar dahil olmak üzere büyük küresel nakliye hatlarıyla ortaklık kuruyoruz.'
        },
        {
          question: 'Gümrük işlemleri genellikle ne kadar sürer?',
          answer: 'Gümrük işlemleri süresi limana ve kargo türüne göre değişir, ancak genellikle 2-5 iş günü arasındadır. Uzman ekibimiz gecikmeleri en aza indirmek için süreci hızlandırır.'
        },
        {
          question: 'Çin\'den ürün tedarikinde yardımcı olabilir misiniz?',
          answer: 'Evet! Özel Çin tedarik hizmetimiz, rekabetçi fiyatlarla kaliteli ürünler almanızı sağlamak için tedarikçi doğrulama, kalite kontrol, satın alma ve lojistik koordinasyonu içerir.'
        },
        {
          question: 'Hangi limanlarda faaliyet gösteriyorsunuz?',
          answer: 'Latakya (Suriye), Cebel Ali (BAE), Qingdao (Çin) ve diğer stratejik küresel ticaret merkezleri dahil olmak üzere büyük limanlardaki operasyonları yürütüyoruz.'
        }
      ]
    },
    contact: {
      title: 'Nakliye Teklifi Alın',
      subtitle: 'Kargo sorgulamanızı gönderin ve ekibimiz 24 saat içinde yanıt versin',
      form: {
        name: 'Ad Soyad',
        email: 'E-posta Adresi',
        phone: 'Telefon Numarası',
        company: 'Şirket Adı',
        service: 'İhtiyaç Duyulan Hizmet',
        serviceOptions: {
          ocean: 'Deniz Taşımacılığı (LCL/FCL)',
          sourcing: 'Çin\'den Ürün Tedariki',
          customs: 'Gümrük İşlemleri',
          other: 'Diğer Hizmetler'
        },
        message: 'Mesajınız / Sorgu Detayları',
        submit: 'Sorgu Gönder'
      },
      info: {
        title: 'İletişim Bilgileri',
        office: 'Ofis Konumu',
        officeAddress: 'Al-Amirkan Mahallesi, Latakya, Suriye',
        whatsapp: 'WhatsApp Desteği',
        email: 'E-posta'
      }
    },
    footer: {
      company: 'COZEY YILDIZ EXPORT L.L.C',
      description: 'Uluslararası nakliye, yük taşımacılığı ve küresel lojistik çözümlerinde güvenilir ortağınız.',
      services: 'Hizmetler',
      quickLinks: 'Hızlı Bağlantılar',
      contact: 'İletişim',
      rights: 'Tüm hakları saklıdır.'
    }
  }
};